// extracted by mini-css-extract-plugin
export var content = "_am-3";
export var list = "_am-4";
export var settingsContent = "_am-7";
export var settingsPanel = "_am-8";
export var state = "_am-6";
export var triggerBadge = "_am-2";
export var triggerButton = "_am-1";
export var triggerShell = "_am-0";
export var unreadDot = "_am-5";